import { OdataManager } from '@/api/odata/odata-manager';
import { DrawingPackage_Marka } from '@/api/model/interfaces';

export default class DrawingPackageMarkaOdata extends OdataManager<DrawingPackage_Marka> {}
